var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02929 9.81299C6.53941 9.81299 4.41602 10.2383 4.41602 11.9405C4.41602 13.6435 6.52806 14.0833 9.02929 14.0833C11.5175 14.0833 13.6425 13.6571 13.6425 11.9549C13.6425 10.2536 11.5313 9.81299 9.02929 9.81299Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2141 4.07978C12.2141 5.91832 10.788 7.40958 9.02779 7.40958C7.26842 7.40958 5.84229 5.91832 5.84229 4.07978C5.84229 2.2412 7.26842 0.75 9.02779 0.75C10.788 0.75 12.2141 2.2412 12.2141 4.07978Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84311 8.60547H3.83662C2.46157 8.82915 1.5 9.35193 1.5 10.4059C1.5 10.9499 1.75864 11.3531 2.2005 11.6455",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1572 8.60547H14.1637C15.5388 8.82915 16.5003 9.35193 16.5003 10.4059C16.5003 10.9499 16.2417 11.3531 15.7998 11.6455",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9098 6.09051C14.9256 5.69316 15.5118 4.55273 15.237 3.42925C15.0149 2.52097 14.2941 1.88467 13.459 1.75928",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08922 6.09051C3.07334 5.69316 2.48716 4.55273 2.762 3.42925C2.98415 2.52097 3.70492 1.88467 4.54001 1.75928",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanGroup);
export default __webpack_public_path__ + "static/media/human-group.a7f7aa1de4def966a43c3992609bb260.svg";
export { ForwardRef as ReactComponent };